<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-body">
    <ng-container *ngIf="dialog$ | async as dialog">
      <div class="text-justify mb-2">If set more than one, multiple winners may be awarded at the close.</div>
    </ng-container>
  </div>
</ng-container>
